import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWheelchairNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.5 13c5.025 0 9.298 3.223 10.863 7.715.06.017.121.036.182.057l9.844 3.368-1.406-4.781a.5.5 0 00-.48-.359H28v-3h2.503a3.5 3.5 0 013.358 2.512l1.368 4.652a7.5 7.5 0 11-2.169 4.376l-10.067-3.444c.005.134.007.269.007.404C23 30.851 17.851 36 11.5 36S0 30.851 0 24.5 5.149 13 11.5 13zM3 24.5a8.5 8.5 0 1016.98-.574l-9.571 2.393-.728-2.91 9.574-2.394A8.5 8.5 0 003 24.5zm33 4.046a4.5 4.5 0 10.971-2.839l5.434 1.86-.971 2.838z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWheelchairNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWheelchairNormalLarge;
